(() => {
  const init = () => {
    document.querySelectorAll('[data-k1-cinema]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const video = root.querySelector('video');
      const choices = [...root.querySelectorAll('[data-film]')];
      const toggle = root.querySelector('[data-play-toggle]');
      const progress = root.querySelector('[data-film-progress]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = matchMedia('(max-width: 749px)');
      let active = choices[0], userPaused = motion.matches, inView = true;
      const update = () => {
        toggle.textContent = video.paused ? '▶ 再生' : 'Ⅱ 停止';
        toggle.setAttribute('aria-label', video.paused ? 'トップ動画を再生' : 'トップ動画を一時停止');
      };
      const play = () => {
        if (userPaused || !inView || document.hidden) return;
        video.play().catch(() => { update(); });
      };
      const select = (button, explicit = false) => {
        active = button;
        root.dataset.activeFilm = button.dataset.film;
        choices.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        root.querySelector('[data-film-name]').textContent = button.dataset.title;
        root.querySelector('[data-film-word]').textContent = button.dataset.word;
        video.poster = mobile.matches ? button.dataset.posterMobile : button.dataset.posterDesktop;
        const next = mobile.matches ? button.dataset.mobile : button.dataset.desktop;
        if (explicit) userPaused = false;
        if (video.getAttribute('src') !== next && (!motion.matches || explicit)) {
          root.classList.remove('is-playing');
          video.src = next;
          video.load();
          progress.style.transform = 'scaleX(0)';
        }
        if (!motion.matches || explicit) play();
        update();
      };
      choices.forEach(b => b.addEventListener('click', () => select(b, true)));
      toggle.addEventListener('click', () => {
        if (video.paused) { userPaused = false; if (!video.getAttribute('src')) select(active, true); else play(); }
        else { userPaused = true; video.pause(); }
      });
      video.addEventListener('playing', () => { root.classList.add('is-playing'); update(); });
      video.addEventListener('pause', update);
      video.addEventListener('timeupdate', () => { if (video.duration) progress.style.transform = `scaleX(${video.currentTime / video.duration})`; });
      video.addEventListener('error', () => { root.classList.remove('is-playing'); update(); });
      document.addEventListener('visibilitychange', () => document.hidden ? video.pause() : play());
      new IntersectionObserver(entries => { inView = entries[0].isIntersecting; inView ? play() : video.pause(); }, { threshold: .1 }).observe(root);
      mobile.addEventListener('change', () => select(active));
      motion.addEventListener('change', () => { userPaused = motion.matches; if (motion.matches) video.pause(); else select(active); });
      select(active);
    });
    document.querySelectorAll('[data-k1-buy-jump]').forEach(link => {
      const info = document.querySelector('[id^="ProductInfo-"]');
      if (info) link.href = '#' + info.id;
    });
    const videos = [...document.querySelectorAll('.k1-product-film video,.k1-film-card video')];
    videos.forEach(v => v.addEventListener('play', () => videos.forEach(other => { if (other !== v) other.pause(); })));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
